<template>
  <Modal :modalOpened="true">
    <div class="bg-white rounded-lg p-6">
        <h4 class="text-lg">{{ content.loading }}</h4>
        <hr class="mt-3 mb-6 opacity-30" />
        <div class="flex flex-col items-center justify-center gap-y-3 py-8 px-4">
            <div class="text-center">
                {{ content.pleaseWaitForPayment }}
            </div>
            <div class="flex items-center justify-center">
                <img class="h-10" src="/static/images/icons/EosIconsThreeDotsLoading.svg" />
            </div>
        </div>
    </div>
  </Modal>
</template>

<script>
export default {
  inject: ["content"],
};
</script>
